<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.codigo }} - {{ $t('descricao') }} : {{ item.descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:properties="dataObject"
					:options="kebabOptions"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:backdrop="!planejamentoModelo"
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
		>
			<template #form>
				<div class="pr-8 pl-12 py-8">
					<h1 class="font-bold text-[#272728] text-2xl !m-0">
						{{ !isEdit ? $t('addQualityProcessing') : $t('editQualityProcessing') }}
					</h1>
					<p class="!m-0 text-[#272728] text-base">Defina os parâmetros de processamento</p>

					<div class="mt-4 flex flex-col gap-4">
						<div class="flex flex-col">
							<div style="display: flex">
								<label class="font-semibold text-[#464947] text-sm uppercase"
									>{{ $t('description') }} *</label
								>
								<Tooltip
									style="margin-left: 0.5rem"
									:titulo="$t('description')"
									:conteudo="$t('inventarioQualidadeDescricao')"
								/>
							</div>
							<InputText v-model="model.descricao" />
						</div>
						<div class="flex flex-col">
							<div style="display: flex">
								<label class="font-semibold text-[#464947] text-sm uppercase"
									>{{ $t('measurement') }} *</label
								>
								<Tooltip
									style="margin-left: 0.5rem"
									:titulo="$t('measurement')"
									:conteudo="$t('inventarioQualidadeMedicao')"
								/>
							</div>
							<DropdownFk
								v-model="model.medicaoId"
								:dropdown-options="medicoes"
								:disabled="isEdit"
							/>
						</div>
						<div>
							<div style="display: flex">
								<label class="font-semibold text-[#464947] text-sm uppercase"
									>{{ $t('significanceLevel') }} *</label
								>
								<Tooltip
									style="margin-left: 0.5rem"
									:titulo="$t('significanceLevel')"
									:conteudo="$t('inventarioQualidadeNivelDeSignificancia')"
								/>
							</div>
							<RadioButton
								id="90"
								v-model="model.nivelDeSignificancia"
								:disabled="isEdit"
								label="90%"
								:model-value="0.1"
								name="nivel-significancia"
							/>
							<RadioButton
								id="95"
								v-model="model.nivelDeSignificancia"
								:disabled="isEdit"
								label="95%"
								:model-value="0.05"
								name="nivel-significancia"
							/>
							<RadioButton
								id="99"
								v-model="model.nivelDeSignificancia"
								:disabled="isEdit"
								label="99%"
								:model-value="0.01"
								name="nivel-significancia"
							/>
						</div>
					</div>

					<div class="container__crud__crudform__buttons">
						<Button
							:label="$t('cancel')"
							color="trv-secondary"
							outlined
							semantic-class="mini"
							@click="changeFormAndCloseAllActions"
						/>
						<Button
							v-if="!isEdit"
							:label="
								avancado
									? isEdit
										? $t('edit')
										: $t('process')
									: isEdit
										? $t('edit')
										: $t('process')
							"
							color="trv-default"
							semantic-class="mini"
							:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
							:loading="estaCarregando"
							@click="saveClick()"
						/>
						<Button
							v-else
							:label="
								avancado
									? isEdit
										? $t('edit')
										: $t('process')
									: isEdit
										? $t('edit')
										: $t('process')
							"
							color="trv-default"
							semantic-class="mini"
							:loading="estaCarregando"
							@click="saveClick()"
						/>
					</div>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../components/Pagination/Pagination'
import RadioButton from '../../../components/RadioButton/RadioButton'
import Tooltip from '../../../components/Tooltip/Tooltip'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import {
	getAllEstratoInventarioQualidade,
	processarEstratoInventarioQualidade,
	updateEstratoInventarioQualidade,
	deleteEstratoInventarioQualidadeByIdList,
} from '../../../services/requests/EstratoInventarioDeQualidadeRequests'
import { medicoesDeQualidadeDropdown } from '../../../services/requests/MedicoesInventarioRequests'

import i18n from '../../../VueI18n'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	name: 'InventarioQualidade',
	components: {
		Button,
		CrudForm,
		CrudTable,
		KebabMenu,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
		RadioButton,
		DropdownFk,
		Tooltip,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	provide() {
		return {
			edit: this.edit,
		}
	},
	data() {
		return {
			medicoes: [],
			inventariosCubagem: [],
			modeloSalvo: undefined,
			processando: false,
			escolhendoModelo: false,
			showExclusionAlert: false,
			headersSelecionados: [
				'dataDoProcessamento',
				'medicao',
				'descricao',
				'codigo',
				'ordemDeServico',
			],
			intention: {},
			help: {},
			modeloEscolhido: '',
			index: 0,
			modelos: [],
			avancado: true,
			planejamentoModelo: false,
			mostrarLoadingProcessando: false,
			mensagemProcessando: this.$t('realizeOProcessamento'),
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				medicaoId: '',
				nivelDeSignificancia: 0.05,
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'IQ',
			},
			tableHeaders: [
				{ key: 'codigo', value: this.$t('code'), isActive: true },
				{
					key: 'descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{ key: 'ordemDeServico', value: this.$t('serviceOrder'), isActive: true },
				{ key: 'medicao', value: this.$t('measurement'), isActive: true },
				{ key: 'nivelDeSignificancia', value: this.$t('significanceLevel'), isActive: false },
				{
					key: 'dataDoProcessamento',
					value: this.$t('processedDate'),
					isActive: true,
				},
			],
			/**
			 * Cubagens para exibir no dropdown
			 */
			cubagens: [],
			/**
			 * Controlar se o botao de processar / editar esta fazendo chamada para o backend
			 */
			estaCarregando: false,
		}
	},
	computed: {
		initModel() {
			return {
				id: '',
				medicaoId: '',
				nivelDeSignificancia: 0.05,
			}
		},
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createEstratoInventarioQualidadeToPost() {
			return {
				id: uuidv4(),
				descricao: this.model.descricao,
				medicaoId: this.model.medicaoId,
				nivelDeSignificancia: this.model.nivelDeSignificancia,
			}
		},
		edit() {
			return this.isEdit
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			let obrigatorios =
				this.model.descricao && this.model.medicaoId && this.model.nivelDeSignificancia

			return obrigatorios
		},
	},

	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => {
				return model.id === value.properties.id
			})

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
				case 'visualizar':
					this.mutationShowMessage({
						messageTitle: this.$t('buscandoModelo'),
						messageText: '',
						messageIcon: 'far fa-info-circle',
						messageType: 'info',
					})

					get(model.id).then((response) => {
						this.isEdit = true
						this.model = model
						this.modelos = response.data.result
						this.planejamentoModelo = true
					})
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['eicb_cd_codigo']
		getAllEstratoInventarioQualidade().then((response) => {
			response.data.result.forEach((estratoInventarioDeQualidade) =>
				this.formataEstratoInventarioFlorestalDeQualidadeParaTabela(estratoInventarioDeQualidade),
			)
			this.modelList = response.data.result
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		medicoesDeQualidadeDropdown().then((response) => {
			this.medicoes = response.data.result.map((pilha) => {
				return {
					id: pilha.id,
					[i18n.t('code')]: pilha.mdco_cd_codigo,
					[i18n.t('description')]: pilha.mdco_ds_descricao,
					[i18n.t('farm')]: pilha.fzda_nm_nome,
					[i18n.t('forestStratification')]: pilha.esfl_ds_descricao,
				}
			})
		})
	},
	methods: {
		verPlanejamento() {
			if (this.modelos.length) {
				this.planejamentoModelo = true
				this.showForm = false
			}
		},
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		handleInput(e) {
			this.headersSelecionados = e.map((m) => m.key)
		},
		saveModel() {},
		searchModel(text) {
			let modelo = this.modelos.find((modelo) =>
				modelo.stan_nm_titulo_modelo.toLowerCase().includes(text.toLowerCase()),
			)

			if (modelo) {
				this.index = this.modelos.indexOf(modelo)
				this.help = {}
			} else this.help = { message: this.$t('modelNotFound'), type: 'warning' }
		},
		handleClick(tipo) {
			this.avancado = tipo === 'avancado'
		},
		async registraInventarioCubagem() {
			this.processando = true
			this.mostrarLoadingProcessando = true
			this.mensagemProcessando = 'Aguarde enquanto os modelos são gerados'

			this.mutationShowMessage({
				messageTitle: this.$t('aviso'),
				messageText: this.$t('modelosGerados'),
				messageIcon: 'far fa-check-circle',
				messageType: 'info',
			})
			await registraEstratoInventarioProcessamento({
				eicb_ds_descricao: this.model.eicb_ds_descricao,
				fk_cbgm_cubagem: this.model.fk_cbgm_cubagem,
				eicb_dt_processamento: new Date(),
				eicb_dt_referencia: new Date(),
			})
				.then((response) => {
					this.model.id = response.data.result.id

					let treino

					if (response.status === 200) {
						treino =
							this.model.eicb_tx_tipo_modelo === 'Afilamento'
								? ajustaModeloAfilamento
								: ajustaModeloVolumetrico

						treino({
							EicbId: this.model.id,
							CubagemId: this.model.fk_cbgm_cubagem,
						})
							.then((response) => {
								this.modelos = response.data.result
								this.processando = false
								this.mostrarLoadingProcessando = false
							})
							.catch(() => {
								this.planejamentoModelo = false
								this.mostrarLoadingProcessando = false
								this.processando = false
								this.mutationShowMessage({
									messageTitle: this.$t('erro'),
									messageText: this.$t('falhaAoCriarProcessamento'),
									messageIcon: 'far fa-cross-circle',
									messageType: 'error',
								})

								this.deletaProcessamento([this.model.id])
							})
					}
				})
				.catch(() => {
					this.planejamentoModelo = false
					this.mostrarLoadingProcessando = false
					this.processando = false
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('falhaAoCriarProcessamento'),
						messageIcon: 'far fa-cross-circle',
						messageType: 'error',
					})

					this.deletaProcessamento([this.model.id])
				})
		},

		/**
		 * Cria novo Estrato inventario qualidade no banco de dados
		 */
		create() {
			this.estaCarregando = true

			processarEstratoInventarioQualidade(this.createEstratoInventarioQualidadeToPost)
				.then((response) => {
					const { data: estratoInventarioQualidade, status } = response

					this.estaCarregando = false
					this.disableSaveButton = false
					this.showForm = false

					if (status === 200) {
						this.cleanModel()
						this.formataEstratoInventarioFlorestalDeQualidadeParaTabela(estratoInventarioQualidade)

						this.modelList.unshift(estratoInventarioQualidade)

						this.showForm = false
						this.emptyValue = ''

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageText: '',
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
						getAllEstratoInventarioQualidade().then((response) => {
							response.data.result.forEach((estratoInventarioDeQualidade) =>
								this.formataEstratoInventarioFlorestalDeQualidadeParaTabela(
									estratoInventarioDeQualidade,
								),
							)
							this.modelList = response.data.result
							this.tableConfiguration.statusTable = this.$t('noRecordFound')
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageText: '',
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
				.catch((error) => {
					var mensagemDeErro = ''
					var data = error.response.data
					if (data.length != 0) {
						mensagemDeErro = data.errors[0].errorMessage
						console.error(mensagemDeErro)
					}
					this.estaCarregando = false
					this.disableSaveButton = false

					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: mensagemDeErro,
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				})
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataEstratoInventarioFlorestalDeQualidadeParaTabela(estratoInventarioDeQualidade) {
			estratoInventarioDeQualidade.isCheckedToDelete = false
			estratoInventarioDeQualidade.dataDoProcessamento =
				estratoInventarioDeQualidade.dataDoProcessamento
					? new Date(estratoInventarioDeQualidade.dataDoProcessamento).toLocaleDateString()
					: ''
		},

		/**
		 * Atualiza estrato inventario cubagem no banco de dados
		 */
		update() {
			this.estaCarregando = true
			updateEstratoInventarioQualidade(this.model.id, {
				Descricao: this.model.descricao,
			})
				.then(() => {
					this.estaCarregando = false
					this.disableSaveButton = false

					const indexModel = this.modelList.map((m) => m.id).indexOf(this.model.id)

					this.$set(this.modelList, indexModel, this.model)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				})
				.catch(() => {
					this.estaCarregando = false
					this.disableSaveButton = false
				})
		},

		/**
		 * Exclui estrato inventario qualidade no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const confirmResult = confirm('Deseja realmente excluir esses registros?')

				if (confirmResult) {
					deleteEstratoInventarioQualidadeByIdList(this.modelsIdWithCheckedToDelete).then(() => {
						this.modelsIdWithCheckedToDelete.forEach((f) => {
							const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
							this.modelList.splice(indexToRemove, 1)
						})

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
						this.showExclusionAlert = false
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)
			this.showForm = true
			this.isEdit = true
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			this.titleForm = `${this.$t('create')} ${this.$t('loggingProcessig')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			this.modeloSalvo = []
			this.modelos = []
			this.model = { ...this.initModel }
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
